{
  "facility.name": "Helsinki-Vantaan drop-off-alue",
  "facility.webpage.url": "https://www.finavia.fi",
  "facility.customerService.url": "https://customerservice.finavia.fi/fi/support/home",
  "facility.privacyPolicy.url": "https://www.finavia.fi/fi/media/7837/download",
  "facility.privacyPolicy.text": "Tietosuojaseloste",

  "document.title": "Helsinki-Vantaa drop-off",

  "page.webPayment.paymentProvider.heading": "Maksupalveluntarjoaja",
  "page.webPayment.paymentProvider.information": "Maksunvälityspalvelun toteuttajana ja maksupalveluntarjoajana toimii Paytrail Oyj (2122839-7) yhteistyössä suomalaisten pankkien ja luottolaitosten kanssa. Paytrail Oyj näkyy maksun saajana tiliotteella tai korttilaskulla ja välittää maksun kauppiaalle. Paytrail Oyj:llä on maksulaitoksen toimilupa. Reklamaatiotapauksissa pyydämme ottamaan ensisijaisesti yhteyttä tuotteen toimittajaan.",
  "page.webPayment.paymentProvider.details1": "Paytrail Oyj, y-tunnus: 2122839-7",
  "page.webPayment.paymentProvider.details2": "Innova 2",
  "page.webPayment.paymentProvider.details3": "Lutakonaukio 7",
  "page.webPayment.paymentProvider.details4": "40100 Jyväskylä",
  "page.webPayment.paymentProvider.url": "https://www.paytrail.com/kuluttaja/tietoa-maksamisesta",

  "page.webPayment.stepFillLicensePlate.info.pay": "Maksa vierailu 48 tunnin sisällä",
  "page.webPayment.stepFillLicensePlate.info.notPaid": "Vierailitko Helsinki-Vantaa drop-off-alueella etkä ole vielä maksanut vierailuasi?",
  "page.webPayment.stepFillLicensePlate.info.licensePlate": "Hae vierailusi syöttämällä rekisteritunnuksesi:",
  "page.webPayment.stepFillLicensePlate.button.find": "Hae ajoneuvo",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.label.licensePlate": "Rekisteritunnus",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.label.enter": "Syötä",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.errors.licensePlate": "Syötä kelvollinen ajoneuvon rekisteritunnus.",
  "page.webPayment.stepFillLicensePlate.formLicensePlate.info.format": "Muodossa ABC-123 tai ABC123",
  "page.webPayment.stepFillLicensePlate.alert.title.noUnpaidParkingEvents": "Rekisteritunnukselle {licensePlate} ei löytynyt maksamattomia vierailuja.",
  "page.webPayment.stepFillLicensePlate.alert.body.reason": "Tähän voi olla eri syitä.",
  "page.webPayment.stepFillLicensePlate.alert.body.desc1": "Vierailusi drop-off-alueella oli maksuton",
  "page.webPayment.stepFillLicensePlate.alert.body.desc2": "Vierailusta on kulunut 48 tuntia ja siitä on lähetetty lasku tai maksumuistutus postitse rekisteritunnuksen perusteella",
  "page.webPayment.stepFillLicensePlate.alert.body.desc3": "Syötit lomakkeelle väärän rekisteritunnuksen",
  "page.webPayment.stepFillLicensePlate.getInvoice.errorToast": "Virhe tietojen haussa. Kokeile myöhemmin uudestaan.",

  "page.webPayment.stepInvoice.info.invoice": "Maksamattomat vierailut",
  "page.webPayment.stepInvoice.info.invoiceDescription": "{count, plural, one {Rekisteritunnuksella {licensePlate} löytyi maksamaton vierailu.} other {Rekisteritunnuksella {licensePlate} löytyi {count} maksamatonta vierailua.}}",
  "page.webPayment.stepInvoice.button.payParking": "Maksa",
  "page.webPayment.stepInvoice.button.payParking.loading": "Ladataan...",
  "page.webPayment.stepInvoice.cardInvoice.parkingStarted": "Vierailu alkoi",
  "page.webPayment.stepInvoice.cardInvoice.duration": "Kesto",
  "page.webPayment.stepInvoice.cardInvoice.parkingPrice": "Vierailumaksu",
  "page.webPayment.stepInvoice.cardInvoice.vatIncluded": "Sis. alv. {vat}% {vatPrice}",
  "page.webPayment.stepInvoice.contactInformation.description": "Sähköpostiosoite vaaditaan kuittia ja mahdollista maksunpalautusta varten.",
  "page.webPayment.stepInvoice.emailAddress": "Sähköpostiosoite",
  "page.webPayment.stepInvoice.form.email.errors.email": "Syötä kelvollinen sähköpostiosoite.",
  "page.webPayment.stepInvoice.form.email.errors.required": "Sähköpostiosoite vaaditaan.",
  "page.webPayment.stepInvoice.error.initiatePayment": "Virhe maksun aloittamisessa. Yritä hetken kuluttua uudelleen.",

  "page.webPayment.stepFinish.info.success": "Maksu suoritettu, kiitos!",
  "page.webPayment.stepFinish.info.failure": "Maksu epäonnistui.",
  "page.webPayment.stepFinish.failureInfo": "Maksu voi epäonnistua monista eri syistä.",
  "page.webPayment.stepFinish.failureInfoList.heading": "Syitä voivat olla esimerkiksi",
  "page.webPayment.stepFinish.failureInfoList.item1": "Peruutit maksamisen",
  "page.webPayment.stepFinish.failureInfoList.item2": "Pankkitilin saldo ei riitä",
  "page.webPayment.stepFinish.failureInfoList.item3": "Luottokortin luottoraja",
  "page.webPayment.stepFinish.failureInfoList.item4": "Yhteysongelma pankin ja maksupalvelun välillä",
  "page.webPayment.stepFinish.failureInfoList.item5": "Maksukortin verkkomaksurajoitukset",
  "page.webPayment.stepFinish.failureInfoList.footer": "Tarvittaessa ota yhteys pankkiisi.",
  "page.webPayment.stepFinish.info.receipt": "Kuitti lähetetään sähköpostiosoitteeseen {email}.",
  "page.webPayment.stepFinish.button.newPayment": "Maksa toinen vierailu",
  "page.webPayment.stepFinish.button.tryAgain": "Yritä uudelleen",
  "page.webPayment.stepFinish.backToFacilitySiteButtonText": "Finavia.fi",

  "page.webPayment.paymentRedirectReceiver.heading": "Maksua käsitellään...",

  "page.webPayment.label.customerService.part1": "Mahdollisissa ongelmatilanteissa ota yhteyttä",
  "page.webPayment.label.customerService.part2": "Finavian asiakaspalveluun",
  "page.webPayment.label.customerService.urlTitle": "Finavian asiakaspalvelu",

  "common.units.hours.short": "h",
  "common.units.minutes.short": "min",
  "common.units.seconds.short": "s",
  "common.button.back": "Takaisin",
  "language": "Kieli",
  "language.fi": "Suomeksi",
  "language.en": "In English",
  "language.sv": "På svenska"
}
